import { render, staticRenderFns } from "./uniformOrder.vue?vue&type=template&id=2d7d4dc9"
import script from "./uniformOrder.vue?vue&type=script&lang=js"
export * from "./uniformOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports